// extracted by mini-css-extract-plugin
export default {"container":"lZd6YTwTsoiIPL643HiC","title":"w2KGEGBsJ9EGFxdUHOo7","name":"y8Wky9EW4IZv07IW6kWv"};